import React, { useContext } from "react";
import { FaWhatsapp } from "react-icons/fa";
import {
  IoArrowForward,
  IoChatbubbleEllipsesOutline,
  IoFlashOutline,
  IoShieldCheckmarkOutline,
} from "react-icons/io5";
import { useTranslation } from "react-i18next";
import { AuthUserContext } from "../context/context";
import { WHATSAPP_CHAT_URL } from "./WhatsAppPurchaseBanner";

const GuestWhatsAppButton = () => {
  const { t } = useTranslation();
  const { currentLocalization } = useContext(AuthUserContext);

  return (
    <div
      className={`guest-whatsapp ${
        currentLocalization === "ar" ? "guest-whatsapp--rtl" : ""
      }`}
    >
      <a
        href={WHATSAPP_CHAT_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={t("Purchase via WhatsApp - NO Account Required")}
        className="guest-whatsapp__cta"
      >
        <FaWhatsapp aria-hidden="true" className="guest-whatsapp__logo" />
        <span className="guest-whatsapp__copy">
          <span className="guest-whatsapp__title">
            {t("Purchase via WhatsApp - NO Account Required")}
          </span>
          {/* <span className="guest-whatsapp__description">
            {t("Chat with us and complete your purchase.")}
            <br />
            {t("No account required.")}
          </span> */}
        </span>
        <IoArrowForward aria-hidden="true" className="guest-whatsapp__arrow" />
      </a>

      <div className="guest-whatsapp__benefits">
        <div className="guest-whatsapp__benefit">
          <IoFlashOutline aria-hidden="true" className="guest-whatsapp__benefit-icon" />
          <span>
            <strong>{t("Quick & Easy")}</strong>
            <span>{t("Under 60 seconds")}</span>
          </span>
        </div>
        <div className="guest-whatsapp__divider" aria-hidden="true" />
        <div className="guest-whatsapp__benefit">
          <IoShieldCheckmarkOutline aria-hidden="true" className="guest-whatsapp__benefit-icon" />
          <span>
            <strong>{t("Secure")}</strong>
            <span>{t("100% Safe")}</span>
          </span>
        </div>
        <div className="guest-whatsapp__divider" aria-hidden="true" />
        <div className="guest-whatsapp__benefit">
          <IoChatbubbleEllipsesOutline aria-hidden="true" className="guest-whatsapp__benefit-icon" />
          <span>
            <strong>{t("No Registration")}</strong>
            <span>{t("Guest purchase")}</span>
          </span>
        </div>
      </div>
    </div>
  );
};

export default GuestWhatsAppButton;
